import { forwardRef, type FC, type HTMLAttributes } from "react";
import classNames from "classnames";

export const Container = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(({ className, ...rest }, ref) => (
  <div className={classNames(className, "container")} {...rest} ref={ref} />
));

export const Row: FC<HTMLAttributes<HTMLDivElement>> = ({ className, ...rest }) => (
  <div className={classNames(className, "row d-flex flex-wrap")} {...rest} />
);

export type ColSizes = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

interface ColProps extends HTMLAttributes<HTMLDivElement> {
  size: ColSizes | BreakpointSizes;
  push?: ColSizes;
}
export const Col: FC<ColProps> = ({ className, size, push, ...rest }) => {
  let sizeCls;
  if (!size) {
    sizeCls = "";
  } else if (typeof size === "object") {
    sizeCls = Object.entries(size)
      .map(([code, size]) => `col-${code}-${size}`)
      .join(" ");
  } else {
    sizeCls = `col-${size}`;
  }

  return <div className={classNames(className, sizeCls, push && `col-push-${push}`)} {...rest} />;
};

interface BreakpointSizes {
  xs?: ColSizes;
  sm?: ColSizes;
  md?: ColSizes;
  lg?: ColSizes;
}
